import { Company } from '@/store/object-values/Company';

import { VIEWS_MODULE_NAMESPACE } from '@/constants/modules';

export const NAMESPACE = 'CompanySettingsModule';
export const FULL_NAMESPACE = `${VIEWS_MODULE_NAMESPACE}/CompanyAdminModule/${NAMESPACE}`;
export const SIZE_OPTIONS_DEFAULT = [{
  label: 'Unknown',
  value: 'unknown',
},
{
  label: '2 to 5 employees',
  value: '2-5',
},
{
  label: '6 to 10 employees',
  value: '6-10',
},
{
  label: '11 to 20 employees',
  value: '11-20',
},
{
  label: '21 to 50 employees',
  value: '21-50',
},
{
  label: '51 to 100 employees',
  value: '51-100',
},
{
  label: '101 to 200 employees',
  value: '101-200',
},
{
  label: 'More than 200 employees',
  value: '> 200',
},
];

export const STATUS_DEFAULT = {
  IDLE: true,

  UPDATE_IN: false,
  UPDATE_SUCESS: false,
  UPDATE_ERROR: false,
};

export const INIT_STATE = {
  STATUS: Object.assign({}, STATUS_DEFAULT),
  SIZE_OPTIONS: Array.from(SIZE_OPTIONS_DEFAULT),
  formData: {},
};

export default {
  namespaced: true,
  state: Object.assign({}, INIT_STATE),
  mutations: {
    SET_STATUS(state, value) {
      const states = Object.keys(state.STATUS);

      if (states.indexOf(value) > -1) {
        states.forEach((key) => {
          state.STATUS[key] = (key === value);
        });
      } else {
        // eslint-disable-next-line
        // TODO: improve this?
      }
    },
    SET_FORMDATA(state, value) {
      const formData = new Company(value.company);
      Object.assign(state.formData, formData);
    },
    SET_FORM_ADDRESS(state, value) {
      state.formData.address = value.slice();
    },
    RESET_STORE(state /* , value */) {
      state.STATUS = Object.assign({}, STATUS_DEFAULT);
      state.SIZE_OPTIONS = Array.from(SIZE_OPTIONS_DEFAULT);
    },
  },
  actions: {
    enterView(/* { commit } */) {
    },
    leaveView({ commit }) {
      commit('RESET_STORE');
    },
    companyUpdate: ({
      rootState,
      state,
      commit,
    }) => {
      if (state.STATUS.IDLE) {
        commit('SET_STATUS', 'UPDATE_IN');

        const localParams = {
          companyUUID: state.formData.uuid,
          params: {
            address: state.formData.address,
            address_details: state.formData.address_details,
            commercial_name: state.formData.commercial_name,
            phone_1: state.formData.phone,
            size: state.formData.size,
          },
        };

        return new Promise((resolve /* ,  reject */) => {
          const api = rootState.Setup.apiInstance;
          api.updateCompany(localParams)
            .then((/* response */) => {
              commit('SET_STATUS', 'UPDATE_SUCESS');
              setTimeout(() => {
                commit('SET_STATUS', 'IDLE');
                /* const data = Object.assign({}, localParams.params);

                 commit(
                  `${UserAccount.FULL_NAMESPACE}/SET_COMPANY`,
                  data, {
                    root: true,
                  },
                ); */
                resolve();
              }, 2400);
            })
            .catch((/* error */) => {
              commit('SET_STATUS', 'UPDATE_ERROR');
              setTimeout(() => {
                commit('SET_STATUS', 'IDLE');
                resolve();
              }, 2400);
            });
        });
      }
      return null;
    },
  },
  modules: {
  },
};
